import { render, staticRenderFns } from "./InternalMessage.vue?vue&type=template&id=1796ad0f&scoped=true"
import script from "./InternalMessage.vue?vue&type=script&lang=js"
export * from "./InternalMessage.vue?vue&type=script&lang=js"
import style0 from "./InternalMessage.vue?vue&type=style&index=0&id=1796ad0f&prod&lang=scss"
import style1 from "./InternalMessage.vue?vue&type=style&index=1&id=1796ad0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1796ad0f",
  null
  
)

export default component.exports